import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs/operators';

export class BreadCrumbItem {

  constructor(private _title: string,
              public routerLink: string[],
              private _router: ActivatedRoute,
              private _translate: TranslateService) {
  }

  public get title(): Observable<string> {
    const hasVars = this._title.match(/{\w+}/);

    if (!hasVars) {
      return this._translate.stream(this._title);
    }

    const clearTitle = this._title.replace(/\s{\w+}/, '');
    const routerProp = hasVars[0].replace('{', '').replace('}', '');
    const params = (this._router.params as BehaviorSubject<any>).getValue();

    return this._translate.stream(clearTitle)
      .pipe(
        switchMap((res: string) => {
         return  of(`${ res } ${ params[routerProp] }`);
        }))
      ;
  }
}
